module.exports = __webpack_public_path__ + "static/media/header_logo.2e4b73c2.png";